@if (infographic) {
  <div class="row infographic m-0 p-0">
    <div class="img-wrap col-md-8">
      <img
        [src]="infographic.backgroundImage"
        width="100%"
        id="infographic-image"
        />
      @for (hotspot of infographic.hotspots; track hotspot; let i = $index) {
        <div
          class="hotspot-button"
          id="hotspot{{ i }}"
          [ngClass]="{ active: isActive(i) }"
          [ngStyle]="getButtonStyle(hotspot)"
          (click)="activateHotspot($event, i)"
          >
          <i class="fas fa-plus"></i>
        </div>
      }
    </div>
    <div
      class="col-md-4 m-0 p-0 hotspots-container"
      [style.height.px]="getImgHeight()"
      >
      @if (activeHotspotIndex == null) {
        <p class="m-3">
          Click on a button to get started.
        </p>
      }
      @for (hotspot of infographic.hotspots; track hotspot; let i = $index) {
        <div [ngClass]="{ active: isActive(i), 'hotspot-popup': true }">
          @if (hotspot.image) {
            <img [src]="hotspot.image" />
          }
          @if (hotspot.title) {
            <h3>{{ hotspot.title }}</h3>
          }
          @if (hotspot.description) {
            <p [innerHTML]="hotspot.description"></p>
          }
          @if (hotspot.link) {
            <a
              class="btn btn-dark"
              [href]="hotspot.link"
              target="_blank"
              >Learn More</a
              >
            }
          </div>
        }
      </div>
    </div>
  }
